<template>
  <div id="footer" dark>
    <hr>
    <div class="left-right-wrapper" >

          <v-flex xs12 sm12 md6 dark class="left-wrapper-footer">
            <form dark color="brown darken-4" class="form-wrapper" @submit.prevent="sendEmail">
          
              <v-flex dark xs12 sm12 md12 class="name-wrapper no-padding">
                <v-flex xs12 sm6 md6 class="no-padding ">
                  <v-text-field dark class="no-padding top-inputs" color="white" type="text" name="from_name" v-model="form.name" :rules="FnRules" label="Your Name" required ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 class="no-padding">
                  <v-text-field dark class="no-padding top-inputs" color="white" type="email" name="reply_to" v-model="form.email" :rules="EmailRules" label="Your E-mail" required ></v-text-field>
                  <v-text-field class="no-padding top-inputs" color="white" type="hidden" name="mname" v-model="mName" label=""></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex md12>
                <v-textarea color="white" class="top-inputs" box dark name="message" label="Your Message" v-model="form.text" :value="form.text" ></v-textarea>
              </v-flex>
                <v-flex md12 class="" v-if="errorm || successm">
                <p class="errorm" v-if="errorm">{{errorm}}</p>
                <p class="successm" v-if="successm">{{successm}}</p>
              </v-flex >
              <v-flex md12 class="button-wrap" v-if="valid && !mName">
                <button type="submit" value='Send' class="footer-butn">Get in Touch</button>
              </v-flex>
            </form>


          </v-flex>
          <v-flex xs12 sm12 md6 class="right-bot-wrapper" >
            <div>
              <h2>Septimus Spyder</h2>
              <div>Send a Raven to Spyder.septimus@gmail.com</div>
              <div>Address: 54, Yew Tree Avenue</div>
              <div>Lichfield, Staffordshire, WS14 9UA </div>
              <div>United Kingdom</div>
            </div>
          </v-flex>
      </div>
          <div class="end-wrapper" >
            <p class="end-text" >
              The Ginger Beer Company UK Ltd. Company number 4352992. VAT Number 144407822
            </p>
          </div>
   </div>
   
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  name: 'Footer',
  data () {
    return {
      validated: false,
      errorm:'',
      successm: '',
      mName:'',
      form: {
        name:'',
        company:'',
        tel: '',
        email: '',
        text: ''
      },
      valid: true,
      FnRules: [
        v => !!v || 'Your name is required',
      ],
      EmailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  props: {
  },
  computed: {
    sendForm () {
      return console.log('not sent')
    }
  },
  methods: {
    clickThis () {
      return console.log('no')
    },
    sendEmail (e) {
      if (!this.mName) {
          emailjs.sendForm('service_aha5f3q', 'template_bmb3dv8', e.target, 'user_wdqzoMAastFUee3043Pxi')
            .then((result) => {
                this.form.name = ""
                this.form.email = ""
                this.form.text = ""
                this.successm = "Thank you, your Email has been sent"
                console.log('SUCCESS!', result.status, result.text);
            }, (error) => {
              this.errorm = "There seems to have been a problem, please try again."
                console.log('FAILED...', error);
            });
      }

      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#footer {
  background-color: #1F1E20 ;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.left-right-wrapper {
  display: flex;
  flex-wrap: wrap;
}
hr {
  margin: 60px 20% 20px 20%;
}
.top-inputs {
}
.left-wrapper-footer {
  padding: 50px 30px;
  justify-content: center;
  display: flex;
}
.button-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-butn {
  background-color: none;
  color: #c1c1c1;
  border: 1.5px #c1c1c1 solid;
  padding: 12px 35px;
  max-width: 200px;
  border-radius: 5px;
  font-size: 16px;
}
.footer-butn:hover {
  color: white;
  border: 1.5px white solid;
}
.bottom-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  width: 100%;
}
.app-modif {
  height:100px;
}
.right-bot-wrapper {
  padding: 50px 30px;
  color: white;
  line-height: 30px;
}
.no-padding {
  padding: 0px!important;
}
.form-background {
  width: contain;
  height: auto;
}
.name-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.input-email {
  width: 100%;
}
.input-name {
  width: 100%;
}
.input-tel {
  width: 100%;
}
.form-wrapper {
  display: flex;
  flex-direction:column;
  max-width: 600px;
  width: 100%;
}
.end-text {
  color: white;
  font-size: 10px;
  margin: 0;
  padding-left: 30px;
}
h2 {
  margin-bottom: 20px;
}
.errorm {
  text-align:center;
  color: red;
}
.successm {
  text-align:center;
  color:green;
}
</style>
